import * as React from 'react';

import style from './index.module.scss';

export const FeedbackSectionPreviewHeader: React.FunctionComponent<{
  className?: string;
}> = ({ className }) => (
  <div className={className}>
    <header className={style.header}>Thank you and follow up question</header>

    <div className={style.subHeader}>
      This is a preview of the landing page where the user can add a comment.
    </div>
  </div>
);
